import * as React from 'react'

import { ApplicationStep, Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import classnames from 'classnames'
import { RedemptionTypesUuids } from 'common/actions'
import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { filtersCreditRedemptionTypesSelector } from 'embed/selectors/filters'
import { loadingSelector } from 'embed/selectors/loading'
import { MultiProductState } from 'embed/reducers'
import { css } from 'emotion'
import { Product } from 'even-ts-static'
import { connect } from 'react-redux'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface RewardsPreferenceStepProps {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  fetchRedemptionTypes: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  currentStep: number
  stepByStepApplicationStep: ApplicationStep | undefined
  totalNumberOfSteps: number
}

const styles = require('embed/components/LoadingIndicator/styles.scss')

interface StoreProps {
  isLoading: boolean
  redemptionTypes: RedemptionTypesUuids | undefined
}

export type Props = RewardsPreferenceStepProps & StoreProps

const StepbystepApplicationStepCreditRedemptionTypesView: React.SFC<Props> = (props) => {
  React.useEffect(() => {
    if (!props.redemptionTypes) {
      props.fetchRedemptionTypes()
    }
  }, [])

  return (
    <StepbystepCreditApplicationWrapper {...props}>
      <StepTitle>How do you prefer to redeem your rewards?</StepTitle>
      {!props.isLoading && (
        <ApplicationField
          field={Fields.RedemptionTypesButtonList}
          onChange={props.handleChangeAndContinue.bind(null, Fields.RedemptionTypesButtonList)}
          product={Product.CreditCard}
          forceFocus={true}
        />
      )}
      {props.isLoading && (
        <ThemeConsumer>
          {({ ctaStyles }) => (
            <div
              data-test-id="spinner"
              className={classnames(
                styles.spinner,
                css`
                  border-left-color: ${ctaStyles?.backgroundColor};
                `,
              )}
            />
          )}
        </ThemeConsumer>
      )}
    </StepbystepCreditApplicationWrapper>
  )
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  isLoading: loadingSelector(state, Product.CreditCard),
  redemptionTypes: filtersCreditRedemptionTypesSelector(state),
})

export const StepbystepApplicationStepCreditRedemptionTypes = connect<StoreProps>(mapStateToProps)(
  StepbystepApplicationStepCreditRedemptionTypesView,
)
